import styled from 'styled-components/macro';
import { desktopHover, pxtorem } from '~/utils/tools';
import { Wrapper } from '~/styles/Wrapper.styled';

export { Wrapper };

export const StyledStarRating = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${pxtorem(12)};
  line-height: 1.2;
  gap: 4px;

  & .stars {
    font-size: 10px;
    line-height: 1;
    transform: translateY(1px);

    & span {
      display: inline-block;
      margin: 0;
      opacity: .5;

      &.active {
        opacity: 1;
      }
    }

    & svg {
      display: inline-block;
    }
  }

  & .count {
    font-weight: 500;
    padding-left: 0.25em;
  }

  @media (min-width: 768px) {
    font-size: ${pxtorem(18)};

    & .stars {
      font-size: 16px;
      transform: translateY(2px);
    }

    & .count {
      color: var(--darkGray);
    }
  }
`;
